import TourSection from '../components/TourSection'
import BookingCTA from '../components/BookingCTA'

export default function Tour() {
  return (
    <main style={{ minHeight: '100vh' }}>
      <div style={{ padding: '80px 32px 0', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ marginBottom: '0', paddingBottom: '24px', borderBottom: '1px solid var(--border)' }}>
          <div className="section-label">All Shows</div>
          <h1 className="section-title">Tour Dates</h1>
        </div>
      </div>
      <div style={{ padding: '0 0 0' }}>
        <TourSection limit={100} />
      </div>
      <BookingCTA />
    </main>
  )
}
